module.exports = __webpack_public_path__ + "img/razorpay.de537882.svg";